import { ENV_VARS } from '@/env';
import { Form, Radio } from 'antd';

const FormRadioGroup = ({
  options = [],
  value = false,
  onChange = () => {},
  name,
  disabled = false,
  id = false,
  alignItems = 'top',
}) => {
  return (
    <Form.Item className="m-0" name={name}>
      <Radio.Group
        id={!id ? name : id}
        className={`form-radio-group-container align-items-${alignItems} ${
          ENV_VARS.REACT_APP_THEME === 'halliburton' ? 'hb-radio-button' : ''
        }`}
        options={options}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default FormRadioGroup;
